import Vue from "vue";
import VueRouter from "vue-router";
import userCode from "@/util/allCode.js";
Vue.use(VueRouter);
let SSOPATH;
let redirectPath;
if (sessionStorage.getItem("navCode")) {
  SSOPATH = JSON.parse(sessionStorage.getItem("navCode"));
  console.log(SSOPATH[0]);
  userCode.map((item) => {
    if (item.code == SSOPATH[0]) {
      redirectPath = item.path;
    }
  });
}
let routes = [
  {
    path: "/",
    name: "pageHome",
    component: () => import("../page/index.vue"),
    redirect: redirectPath,
    children: [
      // 首页
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 区域库
      {
        path: "/arealibrary",
        name: "arealibrary",
        component: () => import("../views/regionalManagement/arealibrary.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 区域审核
      {
        path: "/regReview",
        name: "regReview",
        component: () => import("../views/regionalManagement/regReview.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 行业管理
      {
        path: "/Industry",
        name: "Industry",
        component: () => import("../views/industry/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 实名信息
      {
        path: "/realName",
        name: "realName",
        component: () => import("../views/realName/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 权限管理
      {
        path: "/role",
        name: "role",
        component: () => import("../views/role/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      },
      // 操作日志
      {
        path: "/operationLog",
        name: "operationLog",
        component: () => import("../views/log/index.vue"),
        meta: {
          noNeedCheckLogin: true,
        },
      }
    ],
  },
  // 无权限
  {
    path: "/noper",
    name: "noper",
    meta: {
      noNeedCheckLogin: true,
      a: true,
    },
    component: () => import("../views/405.vue"),
  },
];

const createRouter = () =>
  new VueRouter({
    mode: "hash", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
